import { render } from "./EditarContatos.vue?vue&type=template&id=af3e809c"
import script from "./EditarContatos.vue?vue&type=script&lang=js"
export * from "./EditarContatos.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__